module.exports = __webpack_public_path__ + "img/DURO-LACE-Full-Lace-Hair-System-for-Men-5-300x300.cb640dcd.jpg";